/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */
import { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ConfirmEmail from 'app/modules/mail-history/components/ConfirmEmail';

import { PATH } from 'app/constants/path';

import { App } from '../App';
import { AuthPage, Logout, useAuth } from '../modules/auth';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { PrivateRoutes } from './PrivateRoutes';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

const AppRoutes: FC = () => {
  const { currentUser } = useAuth();
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path="error/*" element={<ErrorsPage />} />
          <Route path="logout" element={<Logout />} />
          <Route path={PATH.MAIL_HISTORY_CONFIRM} element={<ConfirmEmail />} />
          {currentUser ? (
            <>
              <Route path="org/:orgId/*" element={<PrivateRoutes />} />
              <Route path="*" element={<PrivateRoutes />} />
            </>
          ) : (
            <Route path="/*" element={<AuthPage />} />
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
